import React from 'react';
import { motion } from 'framer-motion';
import { ExternalLink } from 'lucide-react';
const fadeIn = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export function BeltTyingSection() {
  return <section className="relative py-0 overflow-hidden" data-id="element-685">
      <div className="grid grid-cols-1 lg:grid-cols-2" data-id="element-686">
        {/* Left: Image Panel */}
        <div className="relative h-64 lg:h-auto min-h-[400px]" data-id="element-687">
          <img src="https://drwzpk38qkpfb.cloudfront.net/www.nwblackbelt.com/uploaded/images/bi2.png" alt="How to Tie Your Belt" className="absolute inset-0 w-full h-full object-cover" data-id="element-688" />
        </div>

        {/* Right: Content Panel */}
        <div className="bg-[#0f1f3d] text-white p-12 lg:p-16 flex flex-col justify-center" data-id="element-689">
          <motion.div initial="hidden" whileInView="visible" viewport={{
          once: true
        }} variants={fadeIn} data-id="element-690">
            <h2 className="text-3xl sm:text-4xl font-black mb-6" data-id="element-691">
              How to Tie Your Belt
            </h2>
            <p className="text-gray-300 text-lg mb-8 leading-relaxed" data-id="element-692">
              Master the proper way to tie your belt with our step-by-step video
              guide.
            </p>
            <a href="https://www.youtube.com/watch?v=iFPsI2yMIhk" target="_blank" rel="noopener noreferrer" className="inline-flex items-center gap-2 px-8 py-4 bg-[#dc2626] text-white text-lg font-bold rounded-lg shadow-lg hover:bg-red-700 transition-colors border-2 border-[#a3d977]/30" data-id="element-693">
              Watch Video
              <ExternalLink className="w-5 h-5" data-id="element-694" />
            </a>
          </motion.div>
        </div>
      </div>
    </section>;
}